/* ==========================================================================
  main.js
========================================================================== */
var toggleThemeBtn = document.querySelector(".toggle-theme"),
	prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)"),
	currentTheme = localStorage.getItem("theme");

currentTheme || (currentTheme = prefersDarkScheme.matches ? "dark" : "light");

document.body.classList.add(currentTheme);

toggleThemeBtn && toggleThemeBtn.addEventListener("click", function (a)
{
	a.preventDefault();
	a = document.body.classList.contains("dark") ? "dark" : "light";
	document.body.classList.remove("dark" === a ? "dark" : "light");
	document.body.classList.add("dark" === a ? "light" : "dark");
	localStorage.setItem("theme", "dark" === a ? "light" : "dark");
	document.cookie = "theme=" + ("dark" === a ? "light" : "dark") + ";expires=0;path=/";
});

var $ = jQuery.noConflict();

function isTouchScreen()
{
	return window.matchMedia('(hover: none)').matches;
}

function topNavbar()
{
	var siteHeaderNavbar = $('.site-header-navbar');

	siteHeaderNavbar.removeClass('fixed-top');

	if (window.innerWidth >= scss_exported_vars.breakpoints.lg)
	{
		if ($(document).scrollTop() > $('.site-header-top').outerHeight())
		{
			siteHeaderNavbar.addClass('fixed-top');
		}
		else
		{
			siteHeaderNavbar.removeClass('fixed-top');
		}
	}
}

function headerThreePictures()
{
	$('.header-three-pictures-el').mouseenter(function ()
	{
		if (window.innerWidth >= scss_exported_vars.breakpoints.lg)
		{
			$(this).siblings().removeClass('active');
			$(this).addClass('active');
		}
	});
}


function recalculateExplodedContent()
{
	var scrollBarWidth = (window.innerWidth - $(window).width());

	//console.log(window.innerWidth + '<' + scss_exported_vars.breakpoints.md);

	if (window.innerWidth <= scss_exported_vars.breakpoints.md)
	{
		$('.home-our-members-list').css('width', 'calc(100vw - ' + (scrollBarWidth + 1) + 'px)');
	}
	else
	{
		$('.home-our-members-list').css('width', 'auto');
	}
}

function acfForms()
{
	// Check ACF
	if (typeof acf === 'undefined')
	{
		return;
	}

	// Date picker & Google Maps compatibility
	$('.acf-google-map input.search, .acf-date-picker input.input').addClass('form-control');

	// Clean errors on submission
	acf.addAction('validation_begin', function ($form)
	{
		$form.find('.acf-error-message').remove();
	});

	// Add alert alert-danger & move below field
	acf.addAction('invalid_field', function (field)
	{
		field.$el.find('.acf-notice.-error').addClass('alert alert-danger').insertAfter(field.$el.find('.acf-input'));
	});
}

function doOnReady()
{
	$('.wp-block-file').prepend('<i class="icss-download"></i> ');

    $('.archiv .list-group li').each(function() {
        $(this).addClass('list-group-item');
    });

	$('.slick-slider').slick({
		prevArrow: '<button type="button" class="slick-prev"><i class="icss-caret-l"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="icss-caret-r"></i></button>'
	});

	$(document).on('change', 'input[type="file"]', function (event)
	{
		var filename = $(this).val();
		if (filename === undefined || filename === "")
		{
			var label = $(".custom-file-label[for='" + $(this).attr("name") + "']");
			label.html(label.data('original'));
		}
		else
		{
			$(".custom-file-label[for='" + $(this).attr("name") + "']").html(event.target.files[0].name);
		}
	});

	$.fn.selectpicker.Constructor.BootstrapVersion = '4';

	$('#companies-tags-filter').selectpicker();

	$('#companies-tags-filter').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue)
	{

		//console.log(isSelected +'|'+ previousValue);

		if (isSelected !== previousValue && $(this).val() !== '')
		{
			window.location = $(this).val();
		}
	});

	topNavbar();
	headerThreePictures();
	recalculateExplodedContent();
	acfForms()

	$('#main-menu').smartmenus();

	var $mainMenuState = $('#main-menu-state');

	if ($mainMenuState.length)
	{
		$mainMenuState.change(function (e)
		{
			var $menu = $('#main-menu');

			if (this.checked)
			{
				$('.main-menu-btn').addClass('menu-open');

				$menu.hide().slideDown(250, function ()
				{
					$menu.css('display', '');
				});
			}
			else
			{
				$('.main-menu-btn').removeClass('menu-open');


				$menu.show().slideUp(250, function ()
				{
					$menu.css('display', '');
				});
			}
		});

		$(window).on('beforeunload unload', function ()
		{
			if ($mainMenuState[0].checked)
			{
				$mainMenuState[0].click();
			}
		});
	}

	resizeHeaderMedia();

	$(".wp-block-gallery a[href$='.jpg'], .wp-block-gallery a[href$='.jpeg'], " +
		".wp-block-gallery a[href$='.png'], .wp-block-gallery a[href$='.gif'], " +
		".wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], " +
		".wp-block-image a[href$='.gif'], .alignleft a[href$='.jpg'], .alignleft a[href$='.png'], " +
		".alignleft a[href$='.gif'], .alignright a[href$='.jpg'], .alignright a[href$='.png'], " +
		".alignright a[href$='.gif']").fancybox();

}

function resizeHeaderMedia()
{
	if ($('.resize-me-header').length)
	{

		var x = window.matchMedia("screen and (max-width:1024px)").matches;

		if (x)
		{
			$('.resize-me-header').css('height', '');
		}
		else
		{
			$('.resize-me-header').css('height', 'calc(100vh - ' + ($('.resize-me-header').offset().top + 0.5) + 'px)');
		}
	}
}

function doOnLoad()
{
	topNavbar();
}

function doOnScroll()
{
	topNavbar();

	if ($('.mouse'))
	{
		var st = $(this).scrollTop(), limit = 350;

		if (st <= limit)
		{
			$('.mouse').css({'opacity': (1 - st / limit)});
		}
		else
		{
			$('.mouse').css({'opacity': 0});
		}
	}

}

function doOnOrientationchange()
{
	topNavbar();
	//toggleNavbarMethod();
	recalculateExplodedContent();
}

function doOnResize()
{
	topNavbar();
	recalculateExplodedContent();
}

function openSearch() {
    document.getElementById("searchWrapper").style.display = "block";
		document.getElementById("s").focus();
}

// Close the full screen search box
function closeSearch() {
    document.getElementById("searchWrapper").style.display = "none";
}

$('body').on('click', '.mouse', function ()
{
	var scroll_distance = $('.resize-me-header').outerHeight() + $('.resize-me-header').offset().top;
	$('html, body').animate({scrollTop: scroll_distance}, 800);
});

$(document).on('ready', doOnReady);
$(document).on('load', doOnLoad);
$(window).on('scroll', doOnScroll);
$(window).on('orientationchange', doOnOrientationchange);
$(window).on('resize', doOnResize);
$(document).keyup(function(e) {
    if(e.keyCode== 27) {
        closeSearch();
    }
});